/**
 * Parses the current URL for a specific query parameter.
 */
export function getURLParameter(parameter: string): string | null {
   return new URLSearchParams(window.location.search).get(parameter);
}
